import styled from "styled-components";
import { Title } from "theme/theme";
import { Type } from "theme/types";

export const TitleAlbumPopup = styled(Title)`
  ${({theme}: Type) => theme?.trivias?.triviaQr?.title}
`;

export const DescriptionAlbumPopup = styled.div`
  ${({ theme }: Type) => theme?.trivias?.triviaQr?.description}
`;

export const ImgAlbumPopup = styled.img`
  ${({ theme }: Type) => theme?.trivias?.triviaQr?.img}
`;

export const ContainerAlbumPopup = styled.div`
  ${({ theme }: Type) => theme?.trivias?.triviaQr?.container}
`
